import React, {useState,useEffect, useContext} from 'react';
import _ from 'lodash';
import moment from 'moment';
import axios from 'axios';
import {Card,Button,Container,Alert} from 'react-bootstrap';

import UserContext from './../contexts/UserContext';
import Utils from './../Utils';
import EditProfile from './EditProfile';
import MessageModal from './../components/MessageModal';

const ConfirmPay = (props) => {
  
  const {userData,setPackage, selectedPackage} = useContext(UserContext);

  const [loading, setLoading] = useState(false);
  const [buyPackage, setBuyPackage] = useState(false);
  const [userLicense, setUserLicense] = useState(false);  
  const [showPayment, setShowPayment] = useState(false);
  const [message, setMessage] = useState({message : false, title: false});
  const checkPackageDetails = () => {
    setLoading('Checking package details.. Please wait..');
    //To be buy package details
    // axios.get('https://staging.svasu.cloud/js/pkgs.json')
    // axios.get(`http://localhost/KS/js/pkgs.json`)
    axios.get(`${process.env.REACT_APP_URL}js/pkgs.json`)
      .then(res => {
        if(res.data){
          setLoading(false);
          const pkgData = _.filter(res.data.packages, p => p.id == selectedPackage());
          Utils.addToUserData({pkg: pkgData[0]});
          setPackage(pkgData[0]);
          setBuyPackage(pkgData[0]);
        }
      })
      .catch(err => console.log(err));

  }

  useEffect(() => {
    checkPackageDetails();
    getUserLicense();
  },[]);
  
  const generateOrder = () => {
    setLoading('Preparing your order.. please wait..');
    return new Promise((resolve,reject) => {
      axios.post(Utils.apiUrl('order/generate'),{pkg: buyPackage.id},Utils.apiHeaders())
      .then(res => {    
        if(_.get(res,'data.success',false)){
          setLoading("Processing payment..");          
          resolve(res.data.data);
        }else{
          throw(res.data);
        }
      }).catch(reject);
    });
  }


  const displayRazorpay = (orderData) => {

    const options = {
      ...orderData,
      image: `${process.env.PUBLIC_URL}/images/logo-blk.png`,      
      theme: {
          color: "#e0a019",
      },
      handler: (res1) => {
        axios.post(Utils.apiUrl("order/success"), {
          ...orderData,
          svasu_product_id  : buyPackage.id,
          orderCreationId   : orderData.order_id,
          razorpayPaymentId : res1.razorpay_payment_id,
          razorpayOrderId   : res1.razorpay_order_id,
          razorpaySignature : res1.razorpay_signature,
        },Utils.apiHeaders()).then(res2 => {
          if(res2.data.success){
            Utils.addToUserData(res2.data.data);            
            setLoading("Your payment is successful, redirecting...");
            setPackage(false);            
            window.setTimeout(() => {              
              gotoBuilder();
            },2000);
          }else{
            throw(res2.data.message);
          }
        }).catch(err => {
          setLoading({mode: "danger", msg: err.message});
        });        
      },
      modal: {
        "ondismiss": function(){
            setLoading(false);
            renderPayButton();
        }
      }
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
}

  const getUserLicense = () => {
    axios.get(Utils.apiUrl(`Package/getUserLicense`), Utils.apiHeaders())
    .then(res => {
      setUserLicense(res.data.data);
    })
    .catch(err => console.log("License Error : ",  err));
  }

  const createPkgExtensionMsg = (sizes) => {    
    const msg = [];
    if(parseInt(buyPackage.cloud) === 0) setShowPayment(true);
    if(parseInt(buyPackage.cloud) === 1 && parseInt(userLicense.cloud) === 1){ //check for cloud plan        
      if(parseInt(sizes.usedSize) >= (parseInt(sizes.pkgSzie) - 1)){ //if used full size
        msg[0] = 'You have almost used your cloud space. To continue further please delete your existing courses to get cloud space.You can take the backup of your courses by downloading them.';        
      }else{ // if enough size available
        msg[0] = `You can still create unlimited courses with around ${parseInt(sizes.pkgSzie) - Math.ceil(sizes.usedSize)} GB cloud space. To utilize more space upto ${sizes.pkgSzie} GB, \nYou can delete your existing courses.`;        
        setShowPayment(true);
      }
    }
    msg[1] = '';    
    const leftDays = parseInt(moment(userLicense.due_date).diff(moment(new Date()), 'days'));
    if(leftDays > 0){
      msg[1] = ` After continuing you will get ${leftDays} extended days for course creation with ${parseInt(sizes.pkgSzie) - Math.ceil(sizes.usedSize)} GB cloud space.`;
    }
    msg[1] = msg[1] + ' Enjoy your customized course creation journey with SVASU!!!';
    setMessage({message: msg, title : 'You are extending the plan..'});
  }

  const getCloudPurchaseMsg = (sizes) => {
    const msg = [];
    const leftDays = parseInt(moment(userLicense.due_date).diff(moment(new Date()), 'days'));
    if(parseInt(userLicense.id) < parseInt(buyPackage.id)){
      ///check for cloud to cloud upgrade
      msg[0] = `You have used around ${Math.ceil(sizes.usedSize)} GB of cloud space with your current plan.${parseInt(leftDays) > 0 ? ' And you still have ' + leftDays + ' days left with you.' : ''}`;
      msg[0] = msg[0] + ` After continuing with the ${buyPackage.category} plan you can use around ${parseInt(sizes.pkgSzie) - Math.ceil(sizes.usedSize)} GB of cloud space.`;
      msg[1] = ` ${Math.ceil(sizes.usedSize) > 0 ? `\nYou can delete your existing courses to get more space, up to ${sizes.pkgSzie} GB. And to get backup of your data you can download it.` : ''}`;
      msg[1] = msg[1] + ` ${parseInt(leftDays) > 0 ? ' \nPlease note that leftover days of your current plan will not be continued further. ' : ''}`;
      msg[1] = msg[1] + ' Enjoy your customized course creation journey with SVASU!!!';
      
      setMessage({message: msg, title: 'You are upgrading the plan!!!'});
      setShowPayment(true);
    }
    else if((parseInt(userLicense.id) > parseInt(buyPackage.id)) && parseInt(userLicense.cloud) === 1){
      ///check for cloud to cloud downgrade
      msg[0] = `You have used around ${Math.ceil(sizes.usedSize)} GB of cloud space with your current plan.${parseInt(leftDays) > 0 ? ' And you still have ' + leftDays + ' days left with you.' : ''}`;
      if(Math.ceil(sizes.usedSize) >= parseInt(sizes.pkgSzie)){
        msg[0] = msg[0] + ` To continue with the ${buyPackage.category} plan, please delete your existing courses.`;
        msg[0] = msg[0] + ' You can take the backup of your courses by downloading them.';
      }else if(Math.ceil(sizes.usedSize) < parseInt(sizes.pkgSzie)){
        msg[0] = msg[0] + `${(parseInt(sizes.pkgSzie) - Math.ceil(sizes.usedSize)) > 0  ? ` After continuing with the ${buyPackage.category} plan you can use around ${parseInt(sizes.pkgSzie) - Math.ceil(sizes.usedSize)} GB of cloud space.`: ''}`;
        msg[0] = msg[0] +  ` ${Math.ceil(sizes.usedSize) > 0 ? `\nYou can delete your existing courses to get more space, up to ${sizes.pkgSzie} GB. ` : ''}` ;
        msg[1] = `${parseInt(leftDays) > 0 ? '\nPlease note that leftover days of your current plan will not be continued further. ' : ''}`;
        msg[1] = msg[1] + ' You can take the backup of your courses by downloading them.';
        msg[1] = msg[1] + ' Enjoy your customized course creation journey with SVASU!!!';          
        setShowPayment(true);
      }
      setMessage({message: msg, title: 'You are changing the plan!!!'});
      
      
    }else if(parseInt(userLicense.cloud) !== 1){
      //check for non-cloud to cloud switch
      msg[0] = `${parseInt(leftDays) > 0 ? `You still have ${leftDays} days with you to create courses without saving them on cloud.`: ``}`;
      msg[0] = msg[0] + ` With the ${buyPackage.category} plan you can save your courses on SVASU cloud and edit them as per your requirements.`;
      msg[1] = ` ${parseInt(leftDays) > 0 ? ' \nPlease note that leftover validity of your current plan will not be continued further.': ''}`;
      msg[1] = msg[1] + ' Enjoy your customized course creation journey with SVASU!!!';
      setShowPayment(true);
      setMessage({message: msg, title : "You are changing the plan..."});
    }
  }

  const getConfirmMessage = () => {    
    const msg = [];
    const sizes = { usedSize  : parseFloat(userLicense.used_size),
                    pkgSzie   : parseInt(buyPackage.storage) + parseInt(buyPackage.extra_storage)
                  }
    const validity = parseInt(buyPackage.actual_validity) + parseInt(buyPackage.extra_validity);
    
    if(_.isEmpty(userLicense.package)){  //first time purchase
      msg[0] = `Welcome to SVASU!!! With the ${buyPackage.category} plan you can create unlimited courses for the next ${validity} days.`;
      msg[1] = `${parseInt(buyPackage.cloud) === 1 ? 'Now you can save and edit your courses on SVASU cloud.' : 
        'Now you can create courses without saving them on the SVASU cloud.'} `;
      msg[1] = msg[1] + 'Enjoy your customized course creation journey with SVASU!!!';
      setMessage({message: msg, title : 'Voila!!'});
      setShowPayment(true);
    }
    else if(parseInt(buyPackage.id) === parseInt(userLicense.id)){ //extension      
      createPkgExtensionMsg(sizes);
    }
    else if(parseInt(buyPackage.cloud) === 1){  //cloud purchase
      getCloudPurchaseMsg(sizes);
    }
    else if(parseInt(buyPackage.cloud) !== 1){
      const leftDays = parseInt(moment(userLicense.due_date).diff(moment(new Date()), 'days'));
      if(parseInt(userLicense.cloud) === 1){
        const leftDays = parseInt(moment(userLicense.due_date).diff(moment(new Date()), 'days'));
        msg[0] = `${Math.ceil(sizes.usedSize) > 0 ? `You still have around ${Math.ceil(userLicense.total_size -  sizes.usedSize)} GB cloud space with you.` : ''}`;
        msg[0] = msg[0] + ` ${parseInt(leftDays) > 0 ? `You can create and save your courses for the next ${leftDays} days. ` : ''}`;
        msg[1] = `${parseInt(sizes.usedSize) > 0 || parseInt(leftDays) > 0 ? 
            `Continuing with the ${buyPackage.category} Non Cloud plan, leftover validities of your current plan will not be continued further.` : 
            `With the ${buyPackage.category} Non Cloud plan you can create unlimited courses without saving it on SVASU cloud.`}`;
        msg[1] = msg[1] + ' \nPlease note that your courses saved on SVASU cloud will get deleted permanently. You can take the backup of your data by downloading it.'
        msg[1] = msg[1] + ' Enjoy your customized course creation journey with SVASU!!!';
        setMessage({message : msg, title : 'You are changing the plan...'});
        setShowPayment(true);
      }
      else{
        msg[0] = `${parseInt(leftDays) > 0 ? `You still have ${leftDays} days with your current plan.`: ''}`;
        msg[0] = msg[0] + ` ${parseInt(leftDays) > 0 ? `\nPlease note that leftover validity of your current plan will not be continued further.` 
          : `With the ${buyPackage.category} Non Cloud plan you can create unlimited courses without saving it on SVASU cloud.`}`;
        msg[1] = 'Enjoy your customized course creation journey with SVASU!!!';
        setMessage({message : msg, title : `${parseInt(buyPackage.id) > parseInt(userLicense.id) ? 'You are upgrading the plan!!!' : 'You are changing the plan...'}`});
        setShowPayment(true) 
      }
    }
  }

  const handleMsgModal = () => {
    setMessage(false);
    if(showPayment) handlePayment();
  }

  const handlePayment = () => {
    Utils.loadJS('https://checkout.razorpay.com/v1/checkout.js','Razorpay SDK failed to load. Are you online?')
      .then(generateOrder)
      .then(displayRazorpay)
      .catch(err => {
        setLoading({mode: "danger", msg: err.message});
      });
  }

  const confirmOrder = () => {
    getConfirmMessage();    
  }

  const gotoBuilder = () => {
    window.location.href = process.env.PUBLIC_URL + '/builder';
  }

  const renderLoading = () => {
    if(_.isObject(loading)){
      return <Alert variant={loading.mode}>{loading.msg}</Alert>;
    }else{
      return <Alert variant="warning">{loading}</Alert>;
    }
  }

  const renderPayButton = () => {
    let payBtn = <Button className="active px-5 py-2" onClick={confirmOrder}>Pay Now</Button>;   
    return <>{payBtn}</>;
  }

  const hasEmptyProfileFields = () => {    
    return _.isEmpty(userData.address) || _.isEmpty(userData.country) || _.isEmpty(userData.mobile);
  };
  
  const renderSelectedPackage = () => {    
    return <div className="alert alert-success">
      {_.get(buyPackage,'category',false)===false && <>No Package Selected</>}
      {_.get(buyPackage,'category',false)!==false && <>
        {buyPackage.category} <hr />
        {buyPackage.title} <hr />
        {parseInt(buyPackage.cloud) ? 'Storage : ' + (parseInt(buyPackage.storage) + parseInt(buyPackage.extra_storage)) + ' GB': 'No Storage'}
        
        <hr />
        Product Cost :  {buyPackage.currency} {buyPackage.offer_price}
      </>}
    </div>;    
  } 


  return <Container className="text-center pb-3">
    <div className="heading mb-4">Let's Get Started! Build Your Course.</div>
    <Card className="card-box mx-auto">
      <Card.Body className="px-5">        
        {buyPackage && <h3 className="my-2">Confirm your purchase order</h3>}
        {!buyPackage && <h3 className="my-2">Information!</h3>}
        <div>{buyPackage && renderSelectedPackage()}</div>

        {hasEmptyProfileFields() && <>        
          <hr />
          <h3 className="my-2">Complete Your Profile</h3>
          <EditProfile />
        </>}
        {loading!==false && renderLoading()}
      </Card.Body>        
      {!hasEmptyProfileFields() && <Card.Footer className="text-center">
        {loading===false && selectedPackage()!==false && renderPayButton()}
   
      </Card.Footer>}
    </Card>
    {message.message  && <MessageModal type={message[0]} message={message.message} title = {message.title} class="msg-modal-text" onHide={handleMsgModal} />}
  </Container>;

}

export default ConfirmPay;